<template>
  <main-layout>
    <template slot="header-title">{{ $t('campaign.title') }}</template>

    <template slot="header-actions">
      <common-button @click="isOpenFormNewCampaign = true">{{ $t('campaign.actions.create') }}</common-button>
    </template>

    <template slot="main">
      <common-loader v-if="!isCampaignsLoaded" />

      <div
        v-else-if="campaigns.length > 0"
        class="container mx-auto grid gap-4 auto-rows-fr"
        :class="'grid-cols-' + columned.length"
      >
        <div v-for="(column, index) in columned" :key="index">
          <campaign
            class="mb-4"
            v-for="(campaign, index) in column"
            v-bind:key="campaign.id"
            :campaign="setGoodDate(campaign)"
            :index="index"
          />
        </div>
      </div>

      <empty v-else :title="$t('campaign.empty.title')" :message="$t('campaign.empty.message')"
        ><a class="cursor-pointer" @click="isOpenFormNewCampaign = true">{{ $t('campaign.actions.create') }}</a></empty
      >

      <new-campaign
        v-if="isOpenFormNewCampaign"
        :open="isOpenFormNewCampaign"
        :site="site"
        @close="closeFormNewCampaign"
      ></new-campaign>
    </template>
  </main-layout>
</template>

<script>
import Empty from '@/components/box-entity-empty.vue'
import { mapState, mapGetters, mapActions } from 'vuex'

import Campaign from '@/components/campaigns/campaign.vue'
import NewCampaign from '@/components/campaigns/FormCampaign.vue'

export default {
  name: 'CampaignList',

  components: { Campaign, NewCampaign, Empty },
  data() {
    return {
      isCampaignsLoaded: true,
      isOpenFormNewCampaign: false,
      columned: []
    }
  },
  computed: {
    ...mapGetters('campaigns', {
      campaigns: 'campaigns'
    }),

    ...mapState('events', {
      events: 'items'
    }),

    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    sorted: function() {
      return this.campaigns.slice().sort(function(a, b) {
        return a.order - b.order
      })
    }
  },
  watch: {
    site: function() {
      this.initCampaignList()
    },
    campaigns: function() {
      !this.isCampaignsLoaded || this.processColumn()
    }
  },
  methods: {
    ...mapActions('campaigns', ['loadCampaign']),

    ...mapActions('badges', ['loadBadges']),

    ...mapActions('events', ['loadEvents']),

    closeFormNewCampaign() {
      this.isOpenFormNewCampaign = false
    },

    toggle(campaign) {
      campaign.visible = !campaign.visible
    },
    toggleCampaign() {
      this.visible.newcampaign = !this.visible.newcampaign
    },
    toggleEditCampaign(campaign) {
      this.visible.newcampaign = !this.visible.newcampaign
    },

    initCampaignList() {
      if (this.site) {
        this.loadCampaign()
          .then(result => {
            return this.loadBadges()
          })
          .then(() => {
            return this.loadEvents(this.site.sitekey)
          })
          .then(() => {
            this.isCampaignsLoaded = true
          })
          .catch(result => {
            setTimeout(() => {
              this.isCampaignsLoaded = true
            }, 1000)
          })
      }
    },
    setGoodDate(campaign) {
      if (campaign.activationdate && campaign.deactivationdate) {
        const newCampaign = { ...campaign }
        newCampaign.activationdate = this._getDate(newCampaign.activationdate, this.site.timezone)
        newCampaign.deactivationdate = this._getDate(newCampaign.deactivationdate, this.site.timezone)
        return newCampaign
      }
      return campaign
    },
    processColumn() {
      // Get size
      this.columned = []

      let nbColumn = 3

      if (document.body.offsetWidth < 770) {
        nbColumn = 2
      }

      if (document.body.offsetWidth < 550) {
        nbColumn = 1
      }

      let currentIndex = 0
      this.sorted.forEach(campaign => {
        if (!this.columned[currentIndex]) {
          this.columned[currentIndex] = []
        }

        this.columned[currentIndex].push(campaign)

        currentIndex++

        if (currentIndex >= nbColumn) {
          currentIndex = 0
        }
      })
    }
  },

  mounted() {
    this.initCampaignList()
    window.addEventListener(
      'resize',
      this._.debounce(() => {
        this.processColumn()
      }, 900)
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Campaign/CampaignList.vue